import * as React from 'react';
import { useEffect, useState } from 'react';

import StarBorderIcon from '@material-ui/icons/StarBorder';
import GroupIcon from '@material-ui/icons/Group';
import ShareIcon from '@material-ui/icons/Share';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import CheckIcon from '@material-ui/icons/Check';
import {
    Box,
    withStyles,
    WithStyles as IWithStyles,
    Theme as ITheme,
} from '@material-ui/core';

import { Link } from 'react-router-dom';
import KfLogo from '../Assets/kflogo.png';
import { RouteComponentProps as IRouteComponentProps } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import services from '../Api/services';
import { subscribeGoToStripe, subscribeMounted } from './UserEvents';
import { sendUserEvent } from './UserEvents/UserEventManager';
import { PackagesList } from './Packages/PackagesList';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK as string);

const styles = (theme: ITheme) => ({
    container: {
        height: '100%',
        width: '100%',
        position: 'relative' as 'relative',
        overflow: 'auto',
        zIndex: 5000,
    },
    content: {
        display: 'flex',
        flexDirection: 'column' as 'column',
    },
    header: {
        display: 'flex',
        color: theme.palette.common.white,
        background: theme.palette.primary.dark,
        fontWeight: 'normal' as 'normal',
        textTransform: 'uppercase' as 'uppercase',
        padding: `${theme.spacing(1.25)}px ${theme.spacing(2.5)}px`,
    },
    title: {
        fontSize: '2.2em',
        display: 'flex',
        alignItems: 'center',
        minWidth: theme.spacing(30),
    },
    checkoutButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        fontSize: theme.spacing(2),
        marginLeft: 'auto',
        borderRadius: theme.spacing(1),
        padding: `0px ${theme.spacing(2.5)}px`,
        minWidth: theme.spacing(25),
        fontWeight: 'bold' as 'bold',
        '&.purchase': {
            fontSize: theme.spacing(3),
        },
    },
    message: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap' as 'wrap',
        overflow: 'auto',
        flexDirection: 'row' as 'row',
    },
});

const payment = ({ classes, location }: IWithStyles & IRouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        sendUserEvent(subscribeMounted, window.location.href);
    }, []);

    const handleClick = async (p: any) => {
        console.log('clicked');
        sendUserEvent(subscribeGoToStripe, window.location.href);
        try {
            setLoading(true);
            const stripe = await stripePromise;
            const { data } = await services.checkoutSession({
                quantity: 1,
                stripePrice: p,
            });

            if (stripe && data) {
                const result = await stripe.redirectToCheckout({
                    sessionId: data['user-management.order/stripe-session-id'],
                });

                if (result.error) {
                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
        }
    };

    return (
        <Box className={classes.container}>
            <Box className={classes.header} style={{ justifyContent: 'flex-end' }}>

                <Box className={classes.title} style={{ marginRight: 'auto', minWidth: '140px' }}>
                <Link to='/video-library/' className={classes.toolbarTitle}>
                <img src={KfLogo} width='120' style={{ marginTop: '18px', marginBottom: '16px' }} />
                </Link>
                </Box>
                <Box sx={{ marginLeft: { xs: '17px', sm: '9px' } }} style={{ marginTop: '4px', marginBottom: '4px', marginRight: '9px', textTransform: 'capitalize'  }}>
                <a href='/video-library' style={{ color: '#5B5B63', textDecoration: 'none' }}>
                <Box style={{ height: '40px', width: 'fit-content', display: 'flex', marginTop: '10px', backgroundColor: '#fff', borderRadius: '10px', justifyContent: 'flex-end' }}>
                   <Box display={{ xs: 'none', sm: 'block' }} style={{ float: 'right', textAlign: 'center', margin: '10px' }}>Back</Box>
                   <Box display={{ xs: 'block', sm: 'none' }} style={{ float: 'right', textAlign: 'center', margin: '10px' }}>Back</Box>
                </Box>
                </a>
                </Box>
            </Box>
            <Box style={{ backgroundColor: '#282832' }} sx={{ textAlign: 'center', fontSize: '58px', color: '#fff', fontWeight: 'bold', height: '200', paddingTop: '100px' }}>
            Plans to suit you
            </Box>


            <Box style={{ backgroundColor: '#282832' }} sx={{ textAlign: 'center', fontSize: '18px', color: '#fff', height: '200', paddingTop: '20px', paddingBottom: '80px' }}>
            All pricing plans cover the essentials, with room to grow. Monthly, Bi-Annual, and Annual Pricing including multi-license packages.
            </Box>


            <Box style={{ backgroundColor: '#282832' }} sx={{ fontSize: '16px', paddingBottom: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', justifyItems: 'center' }}>
            <div style={{ borderRadius: 30, width: 'fit-content', paddingLeft: 14, paddingTop: 2, paddingBottom: 2, paddingRight: 14, border: '1px solid #fff' }}>
            <CheckIcon style={{ fontSize: '38px', color: '#13C805' }} />
            <div style={{ float: 'right', marginLeft: '6px', marginTop: '8px' }}>Cancel with one month's notice</div>
            </div>

            <div style={{ borderRadius: 30, width: 'fit-content', paddingLeft: 14, paddingTop: 2, paddingBottom: 2, paddingRight: 14, border: '1px solid #fff', marginLeft: 20 }}>
            <CheckIcon style={{ fontSize: '38px', color: '#13C805' }} />
            <div style={{ float: 'right', marginLeft: '6px', marginTop: '8px' }}>Online support</div>
            </div>

            <div style={{ borderRadius: 30, width: 'fit-content', paddingLeft: 14, paddingTop: 2, paddingBottom: 2, paddingRight: 14, border: '1px solid #fff', marginLeft: 20 }}>
            <CheckIcon style={{ fontSize: '38px', color: '#13C805' }} />
            <div style={{ float: 'right', marginLeft: '6px', marginTop: '8px' }}>Safe and secure</div>
            </div>
            </Box>


            <Box style={{ backgroundColor: '#2E2E3A', paddingTop: '40px' }} className={classes.message}>
                <PackagesList loading={loading} handleCheckout={handleClick} />
            </Box>

            <Box style={{ backgroundColor: '#2E2E3A' }} sx={{ textAlign: 'center', fontSize: '58px', color: '#fff', fontWeight: 'bold', height: '200', paddingTop: '100px' }}>
            What every plan gets you
            </Box>


            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', backgroundColor: '#2E2E3A' }} sx={{ textAlign: 'center', color: '#fff', paddingTop: '100px', paddingBottom: '20px', marginLeft: 'auto', marginRight: 'auto' }}>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', margin: 10, backgroundColor: '#282832', width: '200px', height: '180px', padding: '40px', borderRadius: '20px' }}>
            <div style={{ display: 'flex', marginBottom: '20px' }}><StarBorderIcon style={{ fontSize: '60px' }} /></div>
            <div style={{ display: 'flex' }}>Cutting Edge Telestration</div>
            </div>


            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', margin: 10, backgroundColor: '#282832', width: '200px', height: '180px', padding: '40px', borderRadius: '20px' }}>
            <div style={{ display: 'flex', marginBottom: '20px' }}><ShareIcon style={{ fontSize: '60px' }} /></div>
            <div style={{ display: 'flex' }}>No watermark on export</div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', margin: 10, backgroundColor: '#282832', width: '200px', height: '180px', padding: '40px', borderRadius: '20px' }}>
            <div style={{ display: 'flex', marginBottom: '20px' }}><GroupIcon style={{ fontSize: '60px' }} /></div>
            <div style={{ display: 'flex' }}>Online collaboration</div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', margin: 10, backgroundColor: '#282832', width: '200px', height: '180px', padding: '40px', borderRadius: '20px' }}>
            <div style={{ display: 'flex', marginBottom: '20px' }}><RadioButtonCheckedIcon style={{ fontSize: '60px' }} /></div>
            <div style={{ display: 'flex' }}>Voice and screen recording</div>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', margin: 10, backgroundColor: '#282832', width: '200px', height: '180px', padding: '40px', borderRadius: '20px' }}>
            <div style={{ display: 'flex', marginBottom: '20px' }}><CloudQueueIcon style={{ fontSize: '60px' }} /></div>
            <div style={{ display: 'flex' }}>10GB secure storage</div>
            </div>



            </Box>


            <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', backgroundColor: '#282832', paddingBottom: '40px' }} sx={{ textAlign: 'center', color: '#fff', paddingTop: '20px', marginLeft: 'auto', marginRight: 'auto' }}>
            <Box sx={{ textAlign: 'center', fontSize: '58px', color: '#fff', fontWeight: 'bold', height: '200', paddingBottom: '40px' }}>
            FAQs
            </Box>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderTop: '2px solid #78787E', borderBottom: '2px solid #78787E', padding: '24px' }}>
How long is my Keyframe trial?
    <br /><br />
<i style={{ fontWeight: 200 }}>
Your Keyframe trial period is 14 days.
</i>
            </div>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderBottom: '2px solid #78787E', padding: '24px' }}>
Is Keyframe compatible with Mac or PC? 
<br />
<br />

 <i style={{ fontWeight: 200 }}>
Yes. As we are an online tool we are compatible with either Apple Mac or Windows PC.
    </i>
            </div>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderBottom: '2px solid #78787E', padding: '24px' }}>
Is Keyframe available on iPad or tablet?
<br />
<br />
 <i style={{ fontWeight: 200 }}>Yes. You can log in on any tablet device to use our software. You do this through your browser.</i>
            </div>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderBottom: '2px solid #78787E', padding: '24px' }}>
Can I get a discount on multiple licenses of Keyframe for other staff members?
<br />
<br />
<i style={{ fontWeight: 200 }}>Yes. We offer discounted pricing on 3, 5, and 9 license packages. Please visit our pricing page here to learn more.</i>
            </div>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderBottom: '2px solid #78787E', padding: '24px' }}>
Is Keyframe available offline?
<br />
<br />
<i style={{ fontWeight: 200 }}>No. Our flexibility is provided by being online and in the cloud. We suggest making your analysis and saving it onto your desktop or saved files for offline review.</i>
            </div>

            <div style={{ textAlign: 'left', width: '70%', fontSize: '18px', borderBottom: '2px solid #78787E', padding: '24px' }}>
What browsers are supported?

<br /><br />
            <i style={{ fontWeight: 200 }}>
We strongly recommend that you use Google Chrome as your browser when using Keyframe. We do not support other browsers and using them may impact your experience.
            </i>
            </div>
            </Box>
        </Box>
    );
};
export const Payment = withStyles(styles)(payment);
